import { render, staticRenderFns } from "./ViewSalesOrderPage.vue?vue&type=template&id=70399a5a"
import script from "./ViewSalesOrderPage.vue?vue&type=script&lang=js"
export * from "./ViewSalesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports